import { render, staticRenderFns } from "./CourseCardsUltimateBundle.vue?vue&type=template&id=7751953f&"
import script from "./CourseCardsUltimateBundle.vue?vue&type=script&lang=js&"
export * from "./CourseCardsUltimateBundle.vue?vue&type=script&lang=js&"
import style0 from "./CourseCardsUltimateBundle.vue?vue&type=style&index=0&id=7751953f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartPrice: require('/opt/build/repo/components/Cart/Price.vue').default,CardsMoreInfoModalMulti: require('/opt/build/repo/components/Cards/MoreInfoModalMulti.vue').default,CardsMoreInfoModal: require('/opt/build/repo/components/Cards/MoreInfoModal.vue').default})
